import { SelectField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { useGetServiceOptions } from '../queries/useGetServiceOptions';
import { DetailsFieldName } from '../types';

export const ServiceField = () => {
    const { data, isFetching } = useGetServiceOptions();
    return (
        <SelectField
            name={DetailsFieldName.ServiceId}
            options={data ?? []}
            label={lt('Service')}
            loader={isFetching}
            disabled
            required
        />
    );
};
